module.exports = __webpack_public_path__ + "static/media/map.21460de1.webp";